import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RoleFormComponent} from './roles/role-form/role-form.component';
import {UserListComponent} from './users/user-list/user-list.component';
import {UserFormComponent} from './users/user-form/user-form.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
    ButtonModule,
    CheckboxModule,
    ConfirmationService,
    ConfirmDialogModule,
    DataTableModule,
    InputTextModule,
    MessagesModule,
    MultiSelectModule,
    PickListModule,
    SharedModule,
    TooltipModule,
} from "primeng/primeng";
import {UsersComponent} from './users/users.component';
import {RouterModule} from "@angular/router";
import {PanelModule} from "primeng/components/panel/panel";
import {TriStateCheckboxModule} from "primeng/components/tristatecheckbox/tristatecheckbox";
import {RoleListComponent} from './roles/role-list/role-list.component';
import {RolesComponent} from "./roles/roles.component";
import {FieldsetModule} from "primeng/components/fieldset/fieldset";
import {DropdownModule} from "primeng/components/dropdown/dropdown";
import {FxsListComponent} from './fxs/fxs-list/fxs-list.component';
import {FxsPickerComponent} from './fxs/fxs-picker/fxs-picker.component';
import {FXDirectiveModule} from "../directives/fx.directive";
import {ValidationService} from "../core/validation-messages/validation.service";
import {ValidationMessagesModule} from "../core/validation-messages/validation-messages.module";
import { MatSortModule, MatTableModule,
    MatCheckboxModule, MatRippleModule, MatInputModule, MatFormFieldModule,
    MatTooltipModule, MatButtonModule, MatSelectModule } from '@angular/material';
import {MatPaginatorModule} from '@angular/material/paginator';


@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PickListModule,
        InputTextModule,
        ButtonModule,
        DataTableModule,
        SharedModule,
        TooltipModule,
        MessagesModule,
        MultiSelectModule,
        DropdownModule,
        TriStateCheckboxModule,
        PanelModule,
        CheckboxModule,
        ConfirmDialogModule,
        FieldsetModule,
        FXDirectiveModule,
        ValidationMessagesModule,
        MatPaginatorModule,
        MatSortModule,
        MatTableModule,
        MatCheckboxModule,
        MatRippleModule,
        MatInputModule,
        MatFormFieldModule,
        MatTooltipModule,
        MatButtonModule,
        MatSelectModule
    ],
    declarations: [RolesComponent, UserListComponent, UserFormComponent,
        UsersComponent, RoleListComponent, RoleFormComponent, FxsListComponent, FxsPickerComponent ],
    providers: [ConfirmationService, ValidationService]
})
export class AdminModule {
}



// WEBPACK FOOTER //
// ./src/app/admin/admin.module.ts